import {Mapper} from '@s-ui/domain'

const SELLER_TYPE_ID_PROFESIONAL = 1
const SELLER_TYPE_ID_PRIVATE = 2
const CONTRACT_ID_PRIVATE = 1

export default class FromRawDataToAdvertisingValueObjectMapper extends Mapper {
  constructor({config, valueObjectFactory}) {
    super({config, valueObjectFactory})

    const {FUEL_TYPES} = config.get('advertising')
    const {OFFER_TYPES_TRANSLATIONS} = config.get('tracking')

    this._config = config
    this._adsNamePageMap = this._config.get('advertising').ADS_NAME_PAGE_MAP
    this._adsNamePageAdDetailsBase = this._config.get('advertising').ADS_NAME_PAGE_AD_DETAILS_BASE
    this._fuelTypes = FUEL_TYPES
    this._vehicleStatus = OFFER_TYPES_TRANSLATIONS
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._lang = this._config.get('URL_CULTURES_MAP')[this._culture]
    this._provinces = config.get('provinces')
    this._valueObjectFactory = valueObjectFactory
    this._adsNamePageAdsDetail = config.get('tracking').ADS_NAME_PAGE_ADS_DETAIL
  }

  _getSellerTypeId = contractId =>
    contractId === CONTRACT_ID_PRIVATE ? SELLER_TYPE_ID_PRIVATE : SELLER_TYPE_ID_PROFESIONAL

  _getAdsNamePage = ({category1Id, offerTypeId}) =>
    `${this._adsNamePageMap[category1Id]?.[offerTypeId]}/${this._adsNamePageAdDetailsBase}`

  map = ({ad = {}, adType = {}, seller = {}}) => {
    const hasFuelType = Boolean(ad.fuelTypeId)
    const {category1Id, offerTypeId} = adType
    const findByAdId = province => province.id === ad.provinceId
    const {label: provinceText} = this._provinces.find(findByAdId)
    const fuelTypeText = hasFuelType ? this._fuelTypes[ad.fuelTypeId][this._culture] : ''

    const data = {
      ad_id: ad.id,
      ad_publisher_type_id: this._getSellerTypeId(seller.contractId),
      ads_name_page: this._getAdsNamePage({category1Id, offerTypeId}),
      brand: ad.make,
      brand_id: ad.makeId,
      car_body_id: ad.bodyTypeId,
      category_level1_id: adType.category1Id,
      category_level2_id: adType.category2Id,
      category_level3_id: adType.category3Id,
      certificated: ad.isCertified,
      color: ad.color,
      company_idwas: seller.dealer.externalContractId,
      country_code: this._lang,
      event_name: 'detail',
      fuel: fuelTypeText,
      fuel_id: ad.fuelTypeId,
      km: ad.km,
      model: ad.model,
      model_id: ad.modelId,
      power: ad.power,
      price: ad.price,
      region_level2: provinceText,
      region_level2_id: ad.provinceId,
      site: this._config.get('TENANT'),
      vehicle_status: this._vehicleStatus[adType.offerTypeId][this._culture],
      vehicle_status_id: adType.offerTypeId,
      version: ad.version,
      warranty: ad.warrantyId,
      year: ad.year
    }

    return this._valueObjectFactory(data)
  }
}
